var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrackerDeliveredCurrent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_470",
    d: "M0 0H19V19H0z",
    className: "cls-1",
    transform: "translate(0 -24)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6828",
    d: "M2.488-24A2.463 2.463 0 0 0 0-21.512v13.436a2.463 2.463 0 0 0 2.488 2.488h13.436a2.463 2.463 0 0 0 2.488-2.488v-12.036l-1 1.089v10.947a1.467 1.467 0 0 1-1.493 1.493H2.488A1.467 1.467 0 0 1 1-8.076v-13.436A1.467 1.467 0 0 1 2.488-23h13.14l.84-.949c-.2 0-.346-.047-.544-.047zm14.555 1.664l-8.615 9.579-4.12-3.654-.653.746 4.479 3.981.373.327.327-.373 8.957-9.952z",
    className: "cls-1",
    transform: "translate(0 24)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6827",
    d: "M0-5h19v-19H0z",
    className: "cls-1",
    transform: "translate(0 24)"
  })), /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#fff}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1912",
    transform: "translate(-206 -4428)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_127",
    fill: "#94c83d",
    stroke: "#94c83d",
    transform: "translate(206 4428)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 21.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_465",
    clipPath: "url(#clip-path)",
    transform: "translate(219 4464)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1911",
    clipPath: "url(#clip-path-2)",
    transform: "translate(0 -24)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1910",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6826",
    d: "M-5-29h27.46v27.46H-5z",
    className: "cls-1",
    transform: "translate(.476 24.476)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrackerDeliveredCurrent);
export default __webpack_public_path__ + "static/media/tracker-delivered-current.785b20c17f00da4c435a460fe8a944d3.svg";
export { ForwardRef as ReactComponent };